var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPhone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPhone",
    transform: "translate(-0.000000, -0.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1671281,0.40356712 C8.45965554,-0.373464751 10.1347201,0.00356776047 10.9696278,1.25953019 L10.9696278,1.25953019 L17.448669,10.975569 C18.2633296,12.2089396 17.9945881,13.8612455 16.8311353,14.7728918 L16.8311353,14.7728918 L13.1949235,17.602229 C12.7151819,17.968856 12.5787021,18.6328345 12.8750021,19.1589175 L12.8750021,19.1589175 L13.1701772,19.6972809 C14.1428769,21.4786704 15.3562912,23.7009308 19.8300352,28.1765744 C24.3037794,32.6522181 26.5242007,33.8632778 28.3087492,34.8360441 L28.3087492,34.8360441 L28.8470758,35.1328331 C29.3732166,35.4251224 30.0343376,35.2860084 30.3980337,34.8064216 L30.3980337,34.8064216 L33.2280213,31.1675237 C34.1395112,30.0035228 35.792173,29.7351379 37.0250843,30.5507917 L37.0250843,30.5507917 L46.740459,37.0302758 C47.9968981,37.8657093 48.3737172,39.5419196 47.5956136,40.8348164 L47.5956136,40.8348164 L45.1527565,44.8952745 C44.4027736,46.1722354 43.1872035,47.1089106 41.7612895,47.5086289 C40.5357834,47.8400088 39.2712831,48.0051831 38.0018146,48 C32.4858184,48 24.4606,45.1007581 13.6805704,34.3208351 C0.128950891,20.7666958 -0.971605037,11.5666159 0.491334757,6.2358528 C0.891494344,4.81012244 1.82801189,3.59465684 3.10451054,2.84415399 L3.10451054,2.84415399 L7.1671281,0.40356712 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/icPhone.75191d2cfcfa20faf48990de4f005abd.svg";
export { ForwardRef as ReactComponent };